"use strict";
module.exports = {
	lastTask: null
};
